var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 5.83333C7.3335 5.46533 7.63216 5.16667 8.00016 5.16667C8.36816 5.16667 8.66683 5.46533 8.66683 5.83333V9.16667C8.66683 9.53467 8.36816 9.83333 8.00016 9.83333C7.63216 9.83333 7.3335 9.53467 7.3335 9.16667V5.83333ZM7.3335 11.1667C7.3335 10.7987 7.63216 10.5 8.00016 10.5C8.36816 10.5 8.66683 10.7987 8.66683 11.1667C8.66683 11.5347 8.36816 11.8333 8.00016 11.8333C7.63216 11.8333 7.3335 11.5347 7.3335 11.1667ZM8.00016 13.8333C5.0595 13.8333 2.66683 11.4407 2.66683 8.5C2.66683 5.55933 5.0595 3.16667 8.00016 3.16667C10.9408 3.16667 13.3335 5.55933 13.3335 8.5C13.3335 11.4407 10.9408 13.8333 8.00016 13.8333M8.00016 1.83333C4.31816 1.83333 1.3335 4.818 1.3335 8.5C1.3335 12.182 4.31816 15.1667 8.00016 15.1667C11.6822 15.1667 14.6668 12.182 14.6668 8.5C14.6668 4.818 11.6822 1.83333 8.00016 1.83333",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 5.83333C7.3335 5.46533 7.63216 5.16667 8.00016 5.16667C8.36816 5.16667 8.66683 5.46533 8.66683 5.83333V9.16667C8.66683 9.53467 8.36816 9.83333 8.00016 9.83333C7.63216 9.83333 7.3335 9.53467 7.3335 9.16667V5.83333ZM7.3335 11.1667C7.3335 10.7987 7.63216 10.5 8.00016 10.5C8.36816 10.5 8.66683 10.7987 8.66683 11.1667C8.66683 11.5347 8.36816 11.8333 8.00016 11.8333C7.63216 11.8333 7.3335 11.5347 7.3335 11.1667ZM8.00016 13.8333C5.0595 13.8333 2.66683 11.4407 2.66683 8.5C2.66683 5.55933 5.0595 3.16667 8.00016 3.16667C10.9408 3.16667 13.3335 5.55933 13.3335 8.5C13.3335 11.4407 10.9408 13.8333 8.00016 13.8333M8.00016 1.83333C4.31816 1.83333 1.3335 4.818 1.3335 8.5C1.3335 12.182 4.31816 15.1667 8.00016 15.1667C11.6822 15.1667 14.6668 12.182 14.6668 8.5C14.6668 4.818 11.6822 1.83333 8.00016 1.83333",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.840455aa5f41f61a8ae7d0a18d35513e.svg";
export { ForwardRef as ReactComponent };